import { useLabels } from '../../i18n/labels';
import { BADGE_XS } from './badgeSize';

interface GenderBadgeProps {
  gender: string;
  short?: boolean;
  /** #531 — the badge names a DIVISION (a bout, a bracket, a group), not one
   *  person: Lithuanian uses the plural ("Vyrai" / "Moterys"). */
  division?: boolean;
  size?: 'xs' | 'sm';
  className?: string;
}

export default function GenderBadge({ gender, short, division, size = 'xs', className = '' }: GenderBadgeProps) {
  const { genderLabel, divisionLabel, genderShort } = useLabels();
  const isMale = gender.toLowerCase() === 'male';
  const sizeClass = size === 'xs' ? BADGE_XS : 'text-xs';
  // #531 — the initial comes from the translations: the English "M" read as
  // "moteris" (woman) in Lithuanian on a male athlete.
  const text = short ? genderShort(gender) : division ? divisionLabel(gender) : genderLabel(gender);
  if (!text) return null; // no gender on the record: no empty pill
  return (
    <span data-testid="gender-badge" className={`badge ${sizeClass} ${isMale ? 'bg-blue-50 text-blue-700 border-blue-200' : 'bg-pink-50 text-pink-700 border-pink-200'} ${className}`}>
      {text}
    </span>
  );
}
